export const sanitizeNumberString = (input: string, decimalSeparator: string): string => {
  const escapedSeparator = decimalSeparator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`[^0-9${escapedSeparator}]`, 'g') // remove everything except digits and separator
  const sanitizedNumber = input.replace(regex, '')
  const hasLeadingMinus = input.trim().startsWith('-')

  return hasLeadingMinus ? `-${sanitizedNumber}` : sanitizedNumber
}
